/** Lock app-controlled page zoom while preserving scrolling and ordinary keyboard input. */
export function installPageZoomLock() {
  if (typeof document === "undefined" || document.documentElement.dataset.pageZoomLocked) return;
  document.documentElement.dataset.pageZoomLocked = "true";

  const viewport = document.querySelector('meta[name="viewport"]');
  viewport?.setAttribute(
    "content",
    "width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover",
  );
  const style = document.createElement("style");
  style.id = "page-zoom-lock";
  style.textContent = `
    html, body, #root { touch-action: pan-x pan-y; }
    @media (pointer: coarse) {
      input, select, textarea { font-size: max(16px, 1em) !important; }
    }
  `;
  document.head.append(style);

  const preventZoom = (event: Event) => event.preventDefault();
  for (const name of ["gesturestart", "gesturechange", "gestureend"]) {
    document.addEventListener(name, preventZoom, { passive: false, capture: true });
  }
  document.addEventListener(
    "touchmove",
    (event) => {
      if (event.touches.length > 1) event.preventDefault();
    },
    { passive: false, capture: true },
  );
  document.addEventListener(
    "wheel",
    (event) => {
      if (event.ctrlKey || event.metaKey) event.preventDefault();
    },
    { passive: false, capture: true },
  );
  document.addEventListener(
    "keydown",
    (event) => {
      if (
        (event.ctrlKey || event.metaKey) &&
        (["+", "=", "-", "_", "0"].includes(event.key) ||
          ["NumpadAdd", "NumpadSubtract", "Numpad0"].includes(event.code))
      ) {
        event.preventDefault();
      }
    },
    { capture: true },
  );
}
